import React, { Component } from 'react'
import { Button } from 'antd'

class ScheduleMachineMenu extends Component {
  handleChangeMachine = value => {
    this.props.changeMachineIndex(value, this.props.data[value].id)
  }
  handleAddMachine = currentSchedule => {
    this.props.addMachine({
      jobId: this.props.jobId,
      userId: this.props.userId,
      scheduleId: currentSchedule
    })
  }
  render() {
    const MachineButtons = props =>
      this.props.data.map((machine, index) => (
        <div key={index}>
          <Button
            type={index === props.currentIndex ? 'primary' : 'default'}
            className="marginLeft5"
            onClick={() => this.handleChangeMachine(index)}
          >
            {index + 1}
          </Button>
        </div>
      ))
    return (
      <div className="scheduleMachineList">
        <MachineButtons currentIndex={this.props.currentIndex} />
        <Button
          type="default"
          icon="plus"
          className="marginLeft10"
          onClick={() =>
            this.handleAddMachine(this.props.data[this.props.currentIndex].schedule_id)
          }
        />
      </div>
    )
  }
}

export default ScheduleMachineMenu



// WEBPACK FOOTER //
// ./src/components/ScheduleMachineMenu.js